import { forwardRef } from 'react'
import { AghanimIcon, IconBase } from '@/icons'

export const FacebookIcon: AghanimIcon = forwardRef(function ({ ...rest }, ref) {
  return (
    <IconBase {...rest} viewBox="0 0 18 18" ref={ref}>
      <path
        d="M16 8.04871C16 3.63071 12.418 0.0487061 8 0.0487061C3.582 0.0487061 0 3.63071 0 8.04871C0 12.042 2.92533 15.3514 6.75 15.9514V10.3614H4.71867V8.04804H6.75V6.28671C6.75 4.28204 7.94467 3.17404 9.772 3.17404C10.6467 3.17404 11.5627 3.33071 11.5627 3.33071V5.29937H10.5533C9.55933 5.29937 9.24933 5.91604 9.24933 6.54871V8.04871H11.468L11.1133 10.362H9.24933V15.952C13.0747 15.3514 16 12.0414 16 8.04871Z"
        fill="currentColor"
      />
    </IconBase>
  )
})
